export const colors = [
    {
        name: 'Red',
        hexValue: '#f44336'
    },
    {
        name: 'Pink',
        hexValue: '#e91e63'
    },
    {
        name: 'Purple',
        hexValue: '#9c27b0'
    },
    {
        name: 'Deep purple',
        hexValue: '#673ab7'
    },
    {
        name: 'Indigo',
        hexValue: '#3f51b5'
    },
    {
        name: 'Blue',
        hexValue: '#2196f3'
    },
    {
        name: 'Light blue',
        hexValue: '#03a9f4'
    },
    {
        name: 'Cyan',
        hexValue: '#00bcd4'
    },
    {
        name: 'Teal',
        hexValue: '#009688'
    },
    {
        name: 'Green',
        hexValue: '#4caf50'
    },
    {
        name: 'Light green',
        hexValue: '#8bc34a'
    },
    {
        name: 'Lime',
        hexValue: '#cddc39'
    },
    {
        name: 'Yellow',
        hexValue: '#ffeb3b'
    },
    {
        name: 'Amber',
        hexValue: '#ffc107'
    },
    {
        name: 'Orange',
        hexValue: '#ff9800'
    },
    {
        name: 'Deep orange',
        hexValue: '#ff5722'
    },
    {
        name: 'Brown',
        hexValue: '#795548'
    },
    {
        name: 'Gray',
        hexValue: '#9e9e9e'
    },
    {
        name: 'Blue gray',
        hexValue: '#607d8b'
    },
];